import React from 'react';
import { motion } from 'framer-motion';
import { FaProjectDiagram, FaUsers, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    window.location.href = '/adminlogout';
  };

  return (
    <div className="min-h-screen p-8">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex justify-between items-center mb-12"
        >
          <h1 className="text-4xl font-bold gradient-text">Admin Dashboard</h1>
          <motion.button
            onClick={handleLogout}
            className="px-6 py-2 glass rounded-lg hover:bg-red-500/20 transition-all flex items-center space-x-2"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaSignOutAlt />
            <span>Logout</span>
          </motion.button>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          <DashboardCard
            icon={<FaProjectDiagram />}
            title="Manage Projects"
            description="Add, edit, or remove projects from the showcase"
            onClick={() => navigate('/showprojects')}
          />
          <DashboardCard
            icon={<FaUsers />}
            title="Manage Students"
            description="Add, edit, or remove student profiles"
            onClick={() => navigate('/showstudents')}
          />
        </div>
      </div>
    </div>
  );
};

const DashboardCard = ({ icon, title, description, onClick }) => (
  <motion.div
    className="glass rounded-xl p-8 cursor-pointer hover:bg-white/10 transition-all"
    whileHover={{ y: -10, scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    onClick={onClick}
  >
    <div className="text-5xl text-primary mb-4">{icon}</div>
    <h2 className="text-2xl font-bold mb-2">{title}</h2>
    <p className="text-gray-400">{description}</p>
  </motion.div>
);

export default AdminDashboard;
